export const allowedHosts = [
    'image.hm.com',
    'sellpy-parse-prod-files.s3.amazonaws.com',
    'hm.cdn.sellpy.net',
];
export const bannerImageResolution = {
    430: '430',
    660: '660',
    960: '960',
    1200: '1200',
};
export const bannerImageSizes = Object.keys(bannerImageResolution);
export const communityContentImageResolution = {
    192: '288',
    302: '453',
};
export const communityContentImageSizes = Object.keys(communityContentImageResolution);
export const defaultImageResolution = {
    88: '88',
    150: '150',
    250: '250',
    376: '376',
    456: '456',
    600: '600',
    768: '768',
    1024: '1024',
    1200: '1200',
};
export const defaultImageSizes = Object.keys(defaultImageResolution);
export const personalizedRecommendationsImageResolution = {
    80: '80',
    216: '216',
};
export const personalizedRecommendationsImageSizes = Object.keys(personalizedRecommendationsImageResolution);
export const resolutionMapping = {
    264: '264',
    396: '396',
    564: '564',
    657: '657',
    768: '768',
    820: '820',
    1260: '1260',
    1536: '1536',
    2160: '2160',
};
export const resolutionMappingSizes = Object.keys(resolutionMapping);
export const productImageResolution = {
    // miniature, smaller resolutions
    34: ['res[s]', 'call=url[file:/product/miniature]'],
    72: ['res[l]', 'call=url[file:/product/miniature]'],
    126: ['res[q]', 'call=url[file:/product/miniature]'],
    // main, medium resolutions
    264: ['res[z]', 'call=url[file:/product/main]'],
    396: ['res[y]', 'call=url[file:/product/main]'],
    564: ['res[w]', 'call=url[file:/product/main]'],
    657: ['res[s]', 'call=url[file:/product/main]'],
    // fullscreen, large resolutions
    1536: ['res[m]', 'call=url[file:/product/fullscreen]'],
    2160: ['res[l]', 'call=url[file:/product/fullscreen]'],
};
export const productImageSizes = Object.keys(productImageResolution);
export const quizImageImageResolution = { 200: '400', 400: '600', 489: '700' };
export const quizImageSizes = Object.keys(quizImageImageResolution);
export const rewardSummaryImageResolution = {
    88: '88',
    150: '150',
    250: '250',
    376: '376',
    456: '456',
    600: '600',
    768: '768',
};
export const rewardSummaryImageSizes = Object.keys(rewardSummaryImageResolution);
export const teaserImageResolution = {
    456: '456',
    480: '480',
    562: '562',
    660: '660',
    795: '795',
    960: '960',
    1200: '1200',
    1440: '1440',
    1920: '1920',
};
export const teaserImageSizes = Object.keys(teaserImageResolution);
//# sourceMappingURL=constants.js.map